import React from 'react'
import { useDropzone } from 'react-dropzone'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close';

const FileElement = ({path, remove}) => {
    return (
        <Box position="relative" padding="8px" paddingRight="40px" mb="15px">
           <IconButton sx={{position: 'absolute', top:0, right:0}} tooltip="Quitar archivo">
                <CloseIcon onClick={remove}/>
            </IconButton>
            <Typography sx={{wordWrap:"break-word"}}>{path}</Typography>
        </Box>
    )   
}

const DropZone = ({ setFiles, accept, clear = false, multiple = false, holdingTitle = "Suelta el archivo ...", waitTitle = "Arrastra o selecciona el archivo fuente" }) => {
    const [files, _setFiles] = React.useState([])

    React.useEffect(() => {
        setFiles([...files])
    } , [files, setFiles])

    React.useEffect(() => {
        clear &&  _setFiles([])
    } , [clear])

    const drop = acceptedFiles => {
        _setFiles([...files, ...acceptedFiles])
    }
    const DZ = useDropzone({ onDrop: React.useCallback(drop, [files, _setFiles]), accept, multiple  })
    const remove = (i) => (e) => {
        e && e.stopPropagation()
        files.splice(i, 1)
        setFiles([...files])
    }
    const flag = files.length?true:false
    return (
        <Box {...DZ.getRootProps()} width="100%">
            <input {...DZ.getInputProps()} />
            <Box minheight="100px" padding="8px" mb="15px" sx={{ border: "1px solid black", borderRadius: "3px"}}>
                {flag? 
                    files.map((file, i) => <FileElement key={i} path={file.path} remove={remove(i)} />)
                    :<Typography>{DZ.isDragActive?holdingTitle:waitTitle}</Typography>
                }                
            </Box>
        </Box>
    )
}

export default DropZone